const replaceTelephoneLink = (value) => {
    if (value) {
        return value.replace(/\[tel\:(...*)\]/, '<a href=\"tel:$1\">$1</a>');
    }
    return '';
};

export default replaceTelephoneLink;

